import React from 'react';
import { useNavigate } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//Cookie
import { getCookie, removeCookie, setCookie } from 'src/webapp/config/cookie';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';

const useRefreshAccessTokenHook = () => {
    const { axiosPostHandler } = useAxiosHook();//axios
    const navigate = useNavigate();//navigator
    const { partner, setPartner, setState, setInfo } = usePartnerStore();
    const { refreshTokenExpires, accessTokenExpires } = useComnHook();//토큰 만료설정

    //토큰유효성체크
    let partnerCd = null;
    //토큰 체크
    const partnerTokenCheckAPI = async () => {
        const NIDAP = getCookie("NIDAP");
        const NIDRP = getCookie("NIDRP");
        const DATA = { REFRESH_TOKEN:NIDRP, ACCESS_TOKEN:NIDAP ?? null };
        const result = await axiosPostHandler(`partnerAuthCheckForPartner.do`, DATA);
        if(!result) { return false; }
        if(result.message === "AUTH_REQUEST_FAILED") {
            removeCookie('NIDAP');
            removeCookie('NIDRP');
            return false;
        }
        if(result.message === "AUTH_REQUEST_CREATE_SUCCESS") {
            const refreshExpires = refreshTokenExpires();
            const accessExpires = accessTokenExpires();
            setCookie("NIDRP", result.data.REFRESH_TOKEN, { expires: refreshExpires, maxAge:(3600 * 24 * 365), path:"/" });
            setCookie("NIDAP", result.data.ACCESS_TOKEN, { expires: accessExpires, maxAge:3600, path:"/" });
        }
        if(result.message === "AUTH_REQUEST_SUCCESS" || result.message === "AUTH_REQUEST_CREATE_SUCCESS") {
            partnerCd = result.data.COMN_CD;
            setPartner(result.data);
            setState(true);
            partnersInfoAPI(result.data.COMN_CD);
            return true;
        }
    };

    //파트너정보API
    const partnersInfoAPI = async(partnerCd) => {
        if(Object.keys(partner).length < 0) { return; }

        const DATA = { PARTNER_CD: partnerCd ?? partner.COMN_CD };
        const result = await axiosPostHandler(`partnersMasterInfoForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result === "SUCCESS") { setInfo(result.data); }
    };

    //getFCMTokenCallback
    //agent에 따른 Bridge적용
    const fcmTokenCheckHandler = async() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		if(isMobile && (window?.webkit?.messageHandlers || window?.dubakiPartners)) {
            if((/iPhone|iPad|iPod/i.test(navigator.userAgent)) && window?.webkit?.messageHandlers?.getFcmInfo?.postMessage) {//IOS APP
                window.webkit.messageHandlers.getFcmInfo.postMessage('');           
            } 
            if((/Android/i.test(navigator.userAgent)) && window?.dubakiPartners) {//Android APP
                window.dubakiPartners.getFcmInfo();           
            } 
        } 
    }
    //FCMtokenUpdateAPI
    const updateFcmTokenAPI = async(token) => {
        if(token != null && partnerCd != null) {
            const DATA = { "PARTNER_CD":partnerCd, "FCM_TOKEN":token };
            const result = await axiosPostHandler(`updateFcmTokenForPartner.do`, DATA);
        }
    }

    return { partnerTokenCheckAPI //토큰 체크
        , partnersInfoAPI //파트너정보API
        , fcmTokenCheckHandler //FCM토큰업데이트호출
        , updateFcmTokenAPI //FCM토큰업데이트
    };
}

export default useRefreshAccessTokenHook;